/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Limitations_PdfInputs */

const en_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF documents do not yet fully comply with PDF/UA-1 (ISO 14289-1)`)
};

const de_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-Dokumente entsprechen noch nicht vollständig PDF/UA-1 (ISO 14289-1)`)
};

const fr_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les documents PDF ne sont pas encore entierement conformes a PDF/UA-1 (ISO 14289-1)`)
};

const es_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los documentos PDF aun no cumplen completamente con PDF/UA-1 (ISO 14289-1)`)
};

const it_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I documenti PDF non sono ancora pienamente conformi a PDF/UA-1 (ISO 14289-1)`)
};

const nl_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-documenten voldoen nog niet volledig aan PDF/UA-1 (ISO 14289-1)`)
};

const pl_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty PDF nie sa jeszcze w pelni zgodne z PDF/UA-1 (ISO 14289-1)`)
};

const fi_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-asiakirjat eivät vielä täysin täytä PDF/UA-1 (ISO 14289-1) -standardia`)
};

const da_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-dokumenter overholder endnu ikke fuldt ud PDF/UA-1 (ISO 14289-1)`)
};

const sv_a11y_statement_limitations_pdf = /** @type {(inputs: A11y_Statement_Limitations_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-dokument uppfyller annu inte fullt ut PDF/UA-1 (ISO 14289-1)`)
};

/**
* | output |
* | --- |
* | "PDF documents do not yet fully comply with PDF/UA-1 (ISO 14289-1)" |
*
* @param {A11y_Statement_Limitations_PdfInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_limitations_pdf = /** @type {((inputs?: A11y_Statement_Limitations_PdfInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Limitations_PdfInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_limitations_pdf(inputs)
	if (locale === "fr") return fr_a11y_statement_limitations_pdf(inputs)
	if (locale === "es") return es_a11y_statement_limitations_pdf(inputs)
	if (locale === "it") return it_a11y_statement_limitations_pdf(inputs)
	if (locale === "nl") return nl_a11y_statement_limitations_pdf(inputs)
	if (locale === "pl") return pl_a11y_statement_limitations_pdf(inputs)
	if (locale === "fi") return fi_a11y_statement_limitations_pdf(inputs)
	if (locale === "da") return da_a11y_statement_limitations_pdf(inputs)
	if (locale === "sv") return sv_a11y_statement_limitations_pdf(inputs)
	return en_a11y_statement_limitations_pdf(inputs)
});